.loadMore {
  display: block;
  font-family: var(--ogm-font-family-1);
  font-size: 14px;
  text-align: center;
  padding: 10px;
  color: #fff;
  text-transform: uppercase;
  margin: 0 auto;
  width: 100%;
  border: solid 2px var(--ogm-mavericks);
  box-sizing: border-box;
  cursor: pointer;
}

@keyframes tickAnimation {
  0% {
    opacity: 0.9;
  }
  20% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  70% {
    opacity: 0.8;
  }
  100% {
    opacity: 0;
  }
}
.miniOCButton {
  font-family: 'Public Sans', sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0px;
}
.miniOCButton {
  box-sizing: border-box;
  border-radius: 3px;
  background-color: var(--ogm-seahawks);
  color: var(--ogm-black);
  align-items: center;
  display: flex;
  margin-right: 20px;
  padding: 10px 15px;
}
.miniOCButton:hover {
  background: var(--ogm-seahawks);
  transition: all 300ms ease;
}
.miniOCButton:active {
  background: var(--ogm-seahawks);
}
.miniOCButton.selected {
  box-shadow: 0 0 0 2px var(--ogm-seahawks) inset;
  position: relative;
  background: transparent;
  color: var(--ogm-black);
}
.miniOCButton.selected:hover {
  background: var(--ogm-seahawks);
  transition: all 300ms ease;
}
.miniOCButton.selected:active {
  background: var(--ogm-seahawks);
}
.miniOCButton.selected .overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  animation: tickAnimation 1.3s ease-in-out both;
  background-color: var(--ogm-seahawks);
  top: 0;
  left: 0;
  border-radius: 3px;
  display: flex;
  align-items: center;
}
.miniOCButton.selected .overlay .animationTick {
  display: block;
  margin: 0 auto;
  position: relative;
}
.miniOCButton.disabled {
  background: var(--ogm-seahawks);
  cursor: default;
  justify-content: center;
}

@media (max-width: 1023px) {
  .ocLogoImg {
    display: block;
    margin: 0 auto;
    transform: scale(0.9);
    max-width: 195px;
  }
  .miniOCButton {
    white-space: nowrap;
    font-family: var(--ogm-font-family-2);
    font-size: 14px;
    line-height: 1;
    margin-right: 0;
    margin-left: 5px;
    justify-content: center;
    text-transform: uppercase;
  }
  .arrowContainer {
    position: relative;
    width: 17px;
    height: 20px;
    display: flex;
  }
  .arrowContainer .forwardArrow {
    transform: scale(0.6);
    position: absolute;
    top: -6px;
    right: -4px;
  }
}
.miniOCButtonDesktopAndTablet {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  align-self: center;
  min-width: 65px;
  padding: 8px;
  border-radius: 3px;
  color: var(--ogm-white);
  text-transform: uppercase;
}
.miniOCButtonDesktopAndTablet:hover {
  color: var(--ogm-seahawks);
  transition: all 300ms ease;
  cursor: pointer;
}
@media (max-width: 767px) {
  .miniOCButtonDesktopAndTablet {
    display: none;
  }
}
.miniOCButtonDesktopAndTablet.login,
.miniOCButtonDesktopAndTablet.signup {
  background: var(--ogm-seahawks);
  color: var(--ogm-timberwolves);
}

.myOCIcon {
  color: white;
  display: block;
  position: relative;
  font-size: 45px;
}

.myOCLoginText {
  margin: 0 0 0 5px;
  vertical-align: top;
  transition: color 250ms ease;
  background-color: var(--ogm-timberwolves);
  padding: 5px;
}
.myOCLoginText:hover {
  color: var(--ogm-seahawks);
}

.filledArrow {
  transform: rotate(0deg);
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 9px solid #fff;
  display: inline-block;
  left: 5px;
  position: relative;
}

.loginButton {
  display: flex;
  flex: 1 0 45px;
  max-width: 190px;
}
.loginButton > button {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  flex: 1;
  padding: 10px;
  font-size: 14px;
  border-radius: 4px;
  background-color: var(--ogm-timberwolves);
}
@media (max-width: 320px) {
  .loginButton > button {
    font-size: 11px;
    padding: 7px;
  }
}

.user {
  color: white;
  background: transparent;
}
